import { fetchWrapper } from '../../common/ApiHelper';

const API_BASE_URL = process.env.REACT_APP_BACKEND_ROOT_DM;

// Upload Management
export const createUploadSignedURL = (filename, filetype) =>
  fetchWrapper(`${API_BASE_URL}/api/data/generate_signed_url`, {
    method: 'POST',
    body: JSON.stringify({ file_name: filename, file_type: filetype }),
  });

// Column description
export const getTabularData = () =>
  fetchWrapper(`${API_BASE_URL}/api/table/get_tables`, {
    method: 'GET',
  });

export const getTableData = (tableName) =>
  fetchWrapper(`${API_BASE_URL}/api/bq/get_description`, {
    method: 'POST',
    body: JSON.stringify({
      table_name: tableName,
    }),
  });

export const postStepTwoData = (dataToPost) =>
  fetchWrapper(`${API_BASE_URL}/api/bq/update_schema`, {
    method: 'POST',
    body: JSON.stringify(dataToPost),
  });

export const postStepOneData = (stepOneModalData) =>
  fetchWrapper(`${API_BASE_URL}/api/table/create_table`, {
    method: 'POST',
    body: JSON.stringify(stepOneModalData),
  });

export const getSelectSources = () =>
  fetchWrapper(`${API_BASE_URL}/api/source/get_sources`, {
    method: 'GET',
  });

export const getDocumentData = () =>
  fetchWrapper(`${API_BASE_URL}/api/document/get_documents`, {
    method: 'GET',
  });

export const postDocumentDataModal = (documentDataModal) =>
  fetchWrapper(`${API_BASE_URL}/api/document/create_document`, {
    method: 'POST',
    body: JSON.stringify(documentDataModal),
  });

export const deleteUploadProcessById = (processId) =>
  fetchWrapper(`${API_BASE_URL}/api/data/delete_process`, {
    method: 'GET',
    params: { process_id: processId },
  });

//get process details
export const getProcessDetails = () =>
  fetchWrapper(`${API_BASE_URL}/api/data/get_process_details`, {
    method: 'GET',
  });

// get step one modal details from notification
export const getStepOneDetailsNotification = (process_id) =>
  fetchWrapper(`${API_BASE_URL}/api/table/get_saved_table`, {
    method: 'GET',
    params: { process_id },
  });

//Edit flow API services
export const getEditStepOneData = (table_id) =>
  fetchWrapper(`${API_BASE_URL}/api/table/get_table_by_id`, {
    method: 'GET',
    params: { table_id },
  });

export const getEditStepTwoTableData = (tableName, datasetID) =>
  fetchWrapper(`${API_BASE_URL}/api/bq/get_description`, {
    method: 'POST',
    body: JSON.stringify({
      table_name: tableName,
      dataset_id: datasetID,
    }),
  });

export const putEditStepOneData = (table_id, editStepOneModalData) =>
  fetchWrapper(`${API_BASE_URL}/api/table/update_table`, {
    method: 'PUT',
    body: JSON.stringify(editStepOneModalData),
    params: { table_id },
  });

export const putEditStepTwoData = (table_id, dataToPost) =>
  fetchWrapper(`${API_BASE_URL}/api/bq/update_saved_schema`, {
    method: 'PUT',
    body: JSON.stringify(dataToPost),
    params: { table_id },
  });

export const getEditDocumentData = (document_id) =>
  fetchWrapper(`${API_BASE_URL}/api/document/get_document_by_id`, {
    method: 'GET',
    params: { document_id },
  });

export const postEditDocumentData = (document_id, editDocumentData) =>
  fetchWrapper(`${API_BASE_URL}/api/document/update_document`, {
    method: 'PUT',
    body: JSON.stringify(editDocumentData),
    params: { document_id },
  });

export const deleteTabularData = (table_id) =>
  fetchWrapper(`${API_BASE_URL}/api/table/delete_table`, {
    method: 'DELETE',
    params: { table_id },
  });

export const deleteDocumentData = (document_id) =>
  fetchWrapper(`${API_BASE_URL}/api/document/delete_document`, {
    method: 'DELETE',
    params: { document_id },
  });

export const getDataDownloadLink = (table_id = '', document_id = '') => {
  if (table_id)
    return fetchWrapper(`${API_BASE_URL}/api/table/download`, {
      method: 'GET',
      params: { table_id },
    });
  if (document_id)
    return fetchWrapper(`${API_BASE_URL}/api/document/download`, {
      method: 'GET',
      params: { document_id },
    });
};
